import {LdapProvisioningConfigEditor} from './LdapProvisioningConfigEditor'
import type {OutboundConnector} from '@/types/outbound-connector'

interface LdapProvisioningConfigCardProps {
    connector: OutboundConnector
    canUpdate: boolean
    onDirtyChange?: (dirty: boolean) => void
}

export function LdapProvisioningConfigCard({connector, canUpdate, onDirtyChange}: LdapProvisioningConfigCardProps) {
    return (
        <LdapProvisioningConfigEditor
            connector={connector}
            canUpdate={canUpdate}
            onDirtyChange={onDirtyChange}
        />
    )
}
